export default "__VITE_ASSET__BS70o6Ko__"